import { useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery } from '@exam-management/graphql';
import { Divider, Flex, Text } from '@shared/components';
import { useMemo } from 'react';

import { QConfigSummaryDetailsContent } from '../../components';

import { getRandomConfigType } from './utils';

interface QConfigSummaryDetailsProps {
  subtaskId: string;
}

export default function QConfigSummaryDetails(props: Readonly<QConfigSummaryDetailsProps>) {
  const { subtaskId } = props;

  const { data: subtaskDetails, loading: isLoading } =
    useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery({
      variables: { getTaskByIdInput: { taskId: subtaskId } },
      fetchPolicy: 'cache-first',
    });

  const { randomConfig, timeLimitValues } = useMemo(() => {
    const metadata =
      subtaskDetails?.wflGetTaskById.task.metadata.__typename === 'TaskMetadataWithQSet'
        ? subtaskDetails.wflGetTaskById.task.metadata.qSet.qConfig.metadata
        : null;
    return {
      timeLimitValues: metadata?.timeLimit?.values ?? [],
      randomConfig: metadata?.randomConfig ?? null,
    };
  }, [subtaskDetails]);

  const parsedRandomType = getRandomConfigType(randomConfig);

  return (
    <Flex
      sx={(theme) => ({
        background: theme.palette.grey[50],
        flexDirection: 'column',
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        p: theme.spacing(4),
        gap: theme.spacing(4),
      })}
    >
      <Text variant='body1Semibold'>ข้อมูลการตั้งค่าของชุดข้อสอบ</Text>
      <Divider />
      <QConfigSummaryDetailsContent
        loading={isLoading}
        timeLimits={timeLimitValues}
        randomConfigType={parsedRandomType}
      />
    </Flex>
  );
}
